import "#/legacy/namespaces.js";
import "#finder-legacy/physician_finder/views/base.js";

// `sp-finder-result-view` renders the slideshow from the finder's published results.
DoctorFinder.Views.SlideshowResults = class SlideshowResults extends DoctorFinder.Views.Base {
  initialize() {
    super.initialize(...arguments);
    return this.$el.addClass("bio");
  }

  handleMobileBreakpointEnter() {
    super.handleMobileBreakpointEnter();
    return this.collection.selectView("bio");
  }

  render() {
    return this;
  }
};
DoctorFinder.Views.SlideshowResults.prototype.template = false;
